module.exports = "https://trybtryb-legacy.web.app/img/book.59b99d4b.svg";